// src/context/media-context.jsx
import { createContext, useContext, useState } from 'react';

const MediaContext = createContext();
export const useMediaContext = () => useContext(MediaContext);

export const MediaProvider = ({ children }) => {
  const [unsentMedia, setUnsentMedia] = useState(false);

  return (
    <MediaContext.Provider value={{
      unsentMedia,
      setUnsentMedia
    }}>
      {children}
    </MediaContext.Provider>
  );
};
